module.exports = __webpack_public_path__ + "img/Grouped order Icon - charcoal.9997e55a.svg";